<template>
  <el-row class="core_three_wrap">
    <el-col class="three_left">
      <div class="left_tit">
        分析生产数据，提供生产效率、质量趋势、设备性能等方面的洞察。 通过预测模型，支持生产决策和资源规划。
      </div>
      <div class="left_desc">
        <div class="desc_item">
          <div class="item_left">
            <img alt="" src="@/assets/xiazai.png">
          </div>
          <div class="item_right">
            <p>生产调度与优化</p>
            <p>利用算法优化生产排程，平衡设备、人力和物料资源，实现高效生产。
              动态调整生产计划，应对紧急订单或设备故障等突发情况。</p>
          </div>
        </div>
        <div class="desc_item">
          <div class="item_left">
            <img alt="" src="@/assets/img/xiazai2.png">
          </div>
          <div class="item_right">
            <p>预测性维护</p>
            <p>分析设备运行数据，预测设备故障并提前安排维护，避免非计划停机。 延长设备使用寿命，降低维护成本。</p>
          </div>
        </div>
        <div class="desc_item">
          <div class="item_left">
            <img alt="" src="@/assets/img/xiazai3.png">
          </div>
          <div class="item_right">
            <p>能源管理与优化</p>
            <p>分析能源消耗数据，优化能源使用效率，降低生产成本。 实现能源使用的实时监控和智能调控。</p>
          </div>
        </div>
        <div class="desc_item">
          <div class="item_left">
            <img alt="" src="@/assets/img/xiazai4.png">
          </div>
          <div class="item_right">
            <p>智能仓储与物流</p>
            <p>优化仓储布局和物料搬运路径，提高仓储效率。 实现物流调度的智能化，降低运输成本。</p>
          </div>
        </div>
      </div>
    </el-col>
    <el-col class="three_right">
      <img alt="" src="@/assets/img/right3 (1).png"/>
    </el-col>
  </el-row>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.core_three_wrap {
  display: flex;
  justify-content: center;
  text-align: left;
  @media screen and (max-width: 768px) {
    flex-wrap: wrap;
  }

  .three_left {
    width: 40%;
    @media screen and (max-width: 768px) {
      width: 90%;
    }

    .left_tit {
      color: #3e3e3e;
      font-size: 20px;
      font-weight: bold;
      @media screen and (max-width: 768px) {
        font-size: 1.2rem;
        margin-top: 20PX;
      }
    }

    .left_desc {
      .desc_item {
        margin-top: 40px;
        display: flex;
        align-items: center;
        padding-left: 50px;

        .item_left {
          img {
            width: 50px;
            height: 50px;
          }
        }

        .item_right {
          margin-left: 20px;

          p {
            margin: 0;

            &:nth-child(1) {
              color: #717171;
              font-size: 16px;
              font-weight: bold;
              @media screen and (max-width: 768px) {
                font-size: 1rem;
                margin-top: 20PX;
              }
            }

            &:nth-child(2) {
              color: #717171;
              font-size: 14px;
              padding: 6px 0;
              @media screen and (max-width: 768px) {
                font-size: 0.8rem;
              }
            }
          }
        }
      }
    }
  }

  .three_right {
    width: 20%;
    height: 100%;
    margin-left: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    @media screen and (max-width: 768px) {
      width: 100%;
      margin-top: 20PX;
    }

    img {
      width: 80%;
      margin-top: 40px;
    }
  }
}
</style>